module.exports = __webpack_public_path__ + "static/media/footer-bg-new.ae4bda07.png";